<template>
  <div class="invitation">
    <div class="header">您正在申请加入：</div>
    <span class="car">{{storeName}}</span>
    <div class="btn">
      <van-button type="info" @click="onOK">立即加入</van-button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {
  API_GET,
  API_POST,
  getLocation,
  getToken,
  clearToken,
  getUnionId,
  API_POST_JSON,
  getInvitationCode
} from "@/apiConfig";
import { getCookie } from "@/utils/auth";
import api from "@/utils/api";
import { Swipe, SwipeItem, Header } from "mint-ui";
export default {
  name: "invitation",
  data() {
    return {
      storeName: ""
    };
  },
  mounted() {
    window.scroll(0, 0);
    this.fetchData();
    this.unionId = getUnionId();
    this.isLogin = getToken() ? true : false;
  },
  methods: {
    fetchData: function() {
      this.loading = false;
      // API_POST("/lianlianche-merchant/store/get", body)
      api({
        url: "/lianlianche-merchant/store/get",
        method: "post",
        data: { id: getCookie("storeId") },
        transformRequest: [
          function(data) {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
        // baseURL: process.env.BASE_URL_FINANCE
      }).then(res => {
        this.loading = true;
        if (res.status == 0) {
          this.storeName = res.data.storeName;
        } else {
        }
      });
    },
    onOK: function() {
      this.loading = false;
      api({
        url: "/lianlianche-user/employee/join/apply",
        method: "post",
        data: { storeId: getCookie("storeId") },
        // baseURL: process.env.BASE_URL_FINANCE
      }).then(res => {
        this.loading = true;
        if (res.status == 0) {
          Toast({
              message: "申请加入中"
            });
        } else {
          Toast({
              message: "申请加入中"
            });
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mint-header-button > a {
  color: #ffffff;
}
.mint-header {
  background-color: rgba(0, 0, 0, 0) !important;
}
.mint-header {
  color: #ffffff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/invitation.vue